import http from "../http-common";

class CommentDataService {
  getAll() {
    return http.get("/comments");
  }

  get(id) {
    return http.get(`/comments/${id}`);
  }

  create(data) {
    return http.post("/comments", data);
  }

  update(id, data) {
    return http.put(`/comments/${id}`, data);
  }

  delete(id) {
    return http.delete(`/comments/${id}`);
  }

  deleteAll() {
    return http.delete(`/comments`);
  }

  // findByComment(name) {
  //   return http.get(`/comments?name=${name}`);
  // }

  // Server-filtered fetch for a specific caseId. Prefer this over getAll()+client-filter
  findByCase(caseId) {
    return http.get(`/comments`, { params: { caseId } });
  }
}

export default new CommentDataService();
